export const calculatePercentage = (
  value: string | number,
  total: string | number
) => {
  if (+total === 0) return 0;
  return Math.round((+value / +total) * 100);
};
